import { Skeleton, Typography } from "@mui/material";
import { memo } from "react";
import { ContentRepeater } from "../../../../common/components";
import { Box, FlexColBox } from "../../../../common/components/Box";
import { RightSidebar } from "../../../../common/components/RightSidebar";
import { spacing } from "../../../../styles/theme";
import { useThemeBreakpoints } from "../../../../utils/themeUtils";
import ColorSelectSkeleton from "../components/ColorSelectSkeleton";
import { PreviewGlassMagnifierSkeleton } from "./PreviewGlassMagnifier/PreviewGlassMagnifierSkeleton";

const DecorationRightSidebar = () => {
  const { isMobile } = useThemeBreakpoints();

  return (
    <RightSidebar>
      <FlexColBox
        gap={{ xs: spacing.regularMobile, md: spacing.regularDesktop }}
      >
        {isMobile && ( //mobile title
          <Box display={"flex"} justifyContent={"space-between"}>
            <Box width={24} />
            <Typography variant="actionBoldBigIcon">
              <Skeleton variant="text" width={100} height={24} />
            </Typography>
            <Skeleton variant="rounded" width={24} height={24} />
          </Box>
        )}

        {/* upload assest button and input */}
        <FlexColBox
          gap={{ xs: spacing.mediumMobile, lg: spacing.mediumDesktop }}
        >
          <Box display={"flex"} justifyContent={"space-between"}>
            <Skeleton variant="rounded" width={50} height={22} />
          </Box>
          <Box display={"flex"} gap={spacing.mediumDesktop}>
            <Skeleton variant="rounded" width={150} height={22} />
            <Skeleton
              variant="rounded"
              width={"100%"}
              height={48}
              sx={{ borderRadius: "8px" }}
            />
            <Skeleton
              variant="rounded"
              width={"100%"}
              height={42}
              sx={{ borderRadius: "8px" }}
            />
          </Box>
        </FlexColBox>

        {/* mobile glass magnifier */}
        {isMobile && (
          <FlexColBox gap={spacing.smallMobile}>
            <Typography variant="textRegularBold">
              <Skeleton variant="text" width={100} height={24} />
            </Typography>
            <PreviewGlassMagnifierSkeleton />
          </FlexColBox>
        )}

        {/* asset type select */}
        <FlexColBox
          gap={{ xs: spacing.mediumMobile, lg: spacing.mediumDesktop }}
        >
          <Skeleton variant="text" width={75} height={24} />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={69}
            sx={{ borderRadius: "8px" }}
          />
        </FlexColBox>

        {/* asset position select */}
        <FlexColBox
          gap={{ xs: spacing.mediumMobile, lg: spacing.mediumDesktop }}
        >
          <Skeleton variant="text" width={75} height={24} />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={40}
            sx={{ borderRadius: "8px" }}
          />
        </FlexColBox>

        {/* asset size selector */}
        <FlexColBox
          gap={{ xs: spacing.mediumMobile, lg: spacing.mediumDesktop }}
        >
          <Box display={"flex"} justifyContent={"space-between"}>
            <Skeleton variant="text" width={25} height={24} />

            <Box display={"flex"} gap={"8px"}>
              <Skeleton variant="text" width={35} height={15} />
              <Skeleton variant="text" width={35} height={15} />
            </Box>
          </Box>
          <FlexColBox
            gap={{ xs: spacing.smallMobile, lg: spacing.smallDesktop }}
          >
            <Skeleton
              variant="rounded"
              width={"100%"}
              height={15}
              sx={{ borderRadius: "12px" }}
            />
            <Box display={"flex"} justifyContent={"space-between"}>
              <Skeleton variant="text" width={25} height={24} />
              <Skeleton variant="text" width={35} height={15} />
            </Box>
          </FlexColBox>
        </FlexColBox>

        {/* asset rotate control */}
        <FlexColBox
          gap={{ xs: spacing.mediumMobile, lg: spacing.mediumDesktop }}
        >
          <Skeleton variant="text" width={25} height={24} />
          <Box display={"flex"} gap={spacing.xsMobile}>
            <ContentRepeater repeatCount={2}>
              <Skeleton
                variant="rounded"
                width={32}
                height={32}
                sx={{ borderRadius: "8px" }}
              />
            </ContentRepeater>
          </Box>
        </FlexColBox>

        <ContentRepeater repeatCount={2}>
          <ColorSelectSkeleton />
        </ContentRepeater>

        {/* Preview */}
        {!isMobile && (
          <FlexColBox gap={spacing.smallDesktop}>
            <Typography variant="textRegularBold">
              <Skeleton variant="text" width={100} height={24} />
            </Typography>
            <PreviewGlassMagnifierSkeleton />
          </FlexColBox>
        )}
      </FlexColBox>
    </RightSidebar>
  );
};

export default memo(DecorationRightSidebar);
